import React from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search , CSVExport } from 'react-bootstrap-table2-toolkit';


export default class ReactDatatable extends React.Component {

render() {

  const { ExportCSVButton } = CSVExport;
  const { SearchBar, ClearSearchButton } = Search
 
  return (
  
                <div>
    
           <ToolkitProvider
    keyField="id"
    data={ this.props.data }
    columns={ this.props.columns } 
    search
    exportCSV
  >
  {
      props => (
        <div>
          <div style={{float:'right'}}>
          <SearchBar { ...props.searchProps } />
          {/* <ClearSearchButton { ...props.searchProps } /> */}
          <ExportCSVButton { ...props.csvProps }>Export CSV!!</ExportCSVButton>
          </div>
          <BootstrapTable
            { ...props.baseProps }
            striped
            hover
            condensed
            bordered={ false }
            pagination={ paginationFactory() }
            noDataIndication="Table is Empty"
          />
        </div>
      )
    }
  </ToolkitProvider>

              
            </div>
       
  );
}
}
